import {
  fetchBasedCall,
  type IHttpCall,
  type IHttpRequest,
  type IHttpResponse,
} from '@hc-frontend/core-utils-net';

import { CleanProspectDto } from './clean-prospect.types';

type CreateProspectOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export async function cleanProspectService(
  baseUrl: string,
  body: CleanProspectDto,
  options?: CreateProspectOptions,
): Promise<IHttpResponse<undefined>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<CleanProspectDto> = {
    url: `${baseUrl}/api/v2/prospects/clean`,
    method: 'POST',
    headers,
    body,
    schemas: {
      request: CleanProspectDto,
      response: undefined,
    },
    ...restOptions,
  };

  return httpCall(request);
}
